import React from "react";
import styles from "./recommendation.module.css";
import {useNavigate} from "react-router-dom";
import RecommendationSectorCard from "./RecommendationSectorCard";
import {useFetchRecommsShort} from "../../../hooks/useQuery/useFetchRecommsShort";
import {LoadingErrorBlock} from "../../../components/shared/LoadingErrorBlock";
import {PageHeader} from "../../../components/shared/PageHeader/PageHeader";
import {HeaderButtons} from "./HeaderButtons/HeaderButtons";
import {Administrator} from "../../../services/models/administrator";
import {SubUser} from "../../../services/models/sub_user";

function isAdministrator(obj: any): obj is Administrator {
    return obj && obj.role === undefined
}

interface AdministratorsPageViewProps {
    user: SubUser | Administrator | null
}

const RecommendationSectorsPageView: React.FC<AdministratorsPageViewProps> = ({user}) => {
    const {recommsShortData, recommsShortError, recommsShortIsLoading} = useFetchRecommsShort();
    const [selectedFilter, setSelectedFilter] = React.useState<string>('alphabet');
    const [searchValue, setSearchValue] = React.useState<string>('');

    let navigate = useNavigate();
    const goToRecommendations = (id: string) => {
        let path = `${id}`;
        navigate(path);
    };
    const isLoading = recommsShortIsLoading;
    const isError = !!(recommsShortError);

    let filteredData = React.useMemo(() => {
        if (!recommsShortData) return [];
        
        // Сначала фильтруем по поисковому запросу
        let data = [...recommsShortData];
        if (searchValue.trim()) {
            data = data.filter(region => 
                region.name.toLowerCase().includes(searchValue.toLowerCase())
            );
        }
        
        // Затем сортируем по выбранному фильтру
        if (selectedFilter === 'alphabet') {
            return data.sort((a, b) => a.name.localeCompare(b.name));
        }
        return data
            .map(region => {
                const statusObj = region.statusesCount.find(s => s.status === selectedFilter);
                return {
                    ...region,
                    _sortCount: statusObj ? statusObj.count : 0
                };
            })
            .sort((a, b) => b._sortCount - a._sortCount || a.name.localeCompare(b.name));
    }, [recommsShortData, selectedFilter, searchValue]);

    const SectorsGrid = (
        <div className={styles.recomsGrid}>
            {filteredData.map((rec) => (
                <div key={rec.id}>
                    <RecommendationSectorCard
                        recommendation={rec}
                        handleLinkClick={goToRecommendations}
                    />
                </div>
            ))}
        </div>
    );

    return (
        <>
            <PageHeader
                title={"Субъекты"}
                isAdmin={isAdministrator(user)}
                enabledBreadcrumbs={false}
                enabledBackBtn={false}
                buttons={
                    <HeaderButtons
                        selectedFilter={selectedFilter}
                        onFilterChange={setSelectedFilter}
                        searchValue={searchValue}
                        onSearchChange={setSearchValue}
                    />
                }
            />
            <LoadingErrorBlock
                isLoading={isLoading}
                isError={isError}
                errorMessage="Ошибка загрузки регионов с информацией. Пожалуйста, попробуйте позже."
            />
            {(!isLoading && !isError && recommsShortData !== undefined) && (
                <>
                    {filteredData.length > 0 ? SectorsGrid : (
                        <p>{searchValue.trim() ? 'Регионы не найдены' : 'Вы ещё не добавили субъекты'}</p>
                    )}
                </>
            )}
        </>
    );
};

export default RecommendationSectorsPageView;
